import * as React from 'react';
import RegForm from 'components/Registration/Registration';
// import { connect } from 'react-redux';
// import { State, Sneakers } from 'types';
// import { fetchNewsfeeds } from 'store/ducks/newsfeeds/actions';
// import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
// import { getNewsfeeds, isLoading } from 'store/ducks/newsfeeds/selectors';

// import { NewsfeedStub } from './Newsfeed.stub';
import './Registration.css';
import { Link } from 'react-router-dom';
import { PageMeta } from 'components';

type Props = {
    match: any;
    // data: any[];
    // fetchNewsfeeds: () => void;
    // isLoading: boolean;
};

export default function Registration(props: Props) {
    // const { isLoading, data, fetchNewsfeeds } = props;

    // React.useEffect(() => {
    //     if (!data.length) {
    //         fetchNewsfeeds();
    //     }
    // }, []);

    // if (isLoading || !data.length) {
    //     return <NewsfeedStub />;
    // }

    return (
        <>
            <PageMeta
                title="Личный кабинет"
                description="Telesputnik.ru является одним из самых авторитетных и быстроразвивающихся интернет-порталов в области телевизионной индустрии, рынка OTT, медиапотребления и производства контента."
                url={`https://telesputnik.ru${props.match.url}`}
            />
            <main className="page page-profile page-profile--no-auth container container--page">
                <div className="page-profile__header">
                    <h1 className="page-title page-profile__title">
                        Личный кабинет
                    </h1>
                </div>
                <div className="page-profile__body">
                    <div className="block-tabs">
                        <div className="block-tabs__content">
                            <div className="block-tabs__tabs">
                                <div className="block-tabs__items">
                                    <Link
                                        to={'/authorization'}
                                        data-id="1"
                                        className="block-tabs__item"
                                    >
                                        Авторизация
                                    </Link>
                                    <Link
                                        to={'/registration'}
                                        data-id="2"
                                        className="block-tabs__item react-tabs__tab--selected"
                                    >
                                        Регистрация
                                    </Link>
                                    <Link
                                        to={'/restore'}
                                        data-id="3"
                                        className="block-tabs__item"
                                    >
                                        Восстановить пароль
                                    </Link>
                                </div>
                            </div>
                            <div className="block-tabs__body">
                                <div className="block-tabs__block block-tabs__block--large _active">
                                    <h2 className="page-profile__subtitle">
                                        Регистрация
                                    </h2>
                                    <RegForm />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
}
